import script from "./RoleSelection.vue?vue&type=script&setup=true&lang=js"
export * from "./RoleSelection.vue?vue&type=script&setup=true&lang=js"

import "./RoleSelection.vue?vue&type=style&index=0&id=8fe447b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8fe447b2"]])

export default __exports__